import { Square, Hourglass, CircleEllipsis, Play, Trophy, CircleStop } from 'lucide-react';

import { BetEventStatusesEnum } from '@shared/constants';

export const getStatusIcon = (status: BetEventStatusesEnum) => {
  switch (status) {
    case BetEventStatusesEnum.CREATED: {
      return CircleEllipsis;
    }
    case BetEventStatusesEnum.STARTED: {
      return Hourglass;
    }
    case BetEventStatusesEnum.FINISHED: {
      return Trophy;
    }
    default: {
      return Square;
    }
  }
};

export const getTogglerDetails = (status: BetEventStatusesEnum) => {
  switch (status) {
    case BetEventStatusesEnum.CREATED: {
      return {
        icon: Play,
        text: 'Start',
        statusText: 'started',
        nextStatus: BetEventStatusesEnum.STARTED,
      };
    }
    case BetEventStatusesEnum.STARTED:
    case BetEventStatusesEnum.FINISHED: {
      return {
        icon: CircleStop,
        text: 'Stop',
        statusText: 'stopped',
        nextStatus: BetEventStatusesEnum.CREATED,
      };
    }
    default: {
      return {
        icon: Square,
        text: 'Status is undefined',
        statusText: '',
        extStatus: '',
      };
    }
  }
};
